import { CALL_ME_START_HOUR, CALL_ME_END_HOUR } from "../utils/constants";

const dateFastSwitch = new Date(Date.now() + 14 * 24 * 60 * 60 * 1000);
const initialState = {
    email: null, 
    dateFastSwitch: `${dateFastSwitch.getDate()}/${dateFastSwitch.getMonth() + 1}/${dateFastSwitch.getFullYear()}`,
    userId: '',
    otp: '',
    shouldDisplayCallMeButtons: false,
}

const GLOBAL_FORM_FIELDS_SET = 'GLOBAL_FORM_FIELDS_SET';
export function globalFormFieldsSet(name, value) {
    return { type: GLOBAL_FORM_FIELDS_SET, name, value }
}

const GLOBAL_FORM_FIELDS_SET_DISPLAY_CALLME = 'GLOBAL_FORM_FIELDS_SET_DISPLAY_CALLME';
export function checkDisplayCallMeButtons () {
    const date = new Date();
    const hour = date.getHours();
    console.log('Checking hours, is visible: ', hour < CALL_ME_END_HOUR && hour > CALL_ME_START_HOUR);
    return { type: GLOBAL_FORM_FIELDS_SET_DISPLAY_CALLME, isVisible: hour < CALL_ME_END_HOUR && hour >= CALL_ME_START_HOUR }
}

export function globalFormFieldsReducer(state = initialState, action) {
    switch (action.type) {
        case GLOBAL_FORM_FIELDS_SET: {
            return { ...state, [action.name]: action.value }
        }
        case GLOBAL_FORM_FIELDS_SET_DISPLAY_CALLME: {
            return { ...state, shouldDisplayCallMeButtons: action.isVisible }
        }
        default: {
            return state;
        }
    }
}